import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Check if code is running on the server
 */
export function isServer() {
  return typeof window === 'undefined'
}

/**
 * Get the API base URL with fallback to the current domain
 * @returns The API base URL
 */
export const getApiBaseUrl = (): string => {
  // In development, use the relative path
  if (import.meta.env.DEV) {
    return '/.netlify/functions';
  }
  
  // In production, use the current domain
  if (typeof window !== 'undefined') {
    const currentDomain = window.location.origin;
    return `${currentDomain}/.netlify/functions`;
  }
  
  // Fallback to relative path
  return '/.netlify/functions';
};

/**
 * Production-safe logging utility
 * Logs in development mode, sends to Sentry in production
 */
export const logger = {
  log: (...args: any[]) => {
    if (import.meta.env.DEV) {
      console.log(...args);
    }
  },
  warn: (...args: any[]) => {
    if (import.meta.env.DEV) {
      console.warn(...args);
    }
  },
  error: (...args: any[]) => {
    if (import.meta.env.DEV) {
      console.error(...args);
    }
    
  }
};
